import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/app/homepage/components/HomepageInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/components/common/Header.tsx");
